// src/components/pages/AboutMe.jsx
import {
  aboutMeContentMain,
  aboutMeContentSecondary,
  aboutMeHighlights,
} from "../../data/aboutMeContent";
import "../styles/about.css";

export const AboutMe = () => {
  return (
    <section
      id="about"
      className="section section--first"
      aria-label="About me section"
    >
      <div className="about_container">
        <h2 className="sectionLabel">About</h2>

        {/* Key facts — scannable summary for recruiters */}
        <div className="about_highlights">
          {aboutMeHighlights.map(({ label, value }) => (
            <div key={label} className="about_highlight_item">
              <span className="about_highlight_label">{label}</span>
              <span className="about_highlight_value">{value}</span>
            </div>
          ))}
        </div>

        {aboutMeContentMain.map((paragraph, index) => (
          <p key={index} className="sectionText">
            {paragraph}
          </p>
        ))}

        {aboutMeContentSecondary.map((paragraph, index) => (
          <p key={`secondary-${index}`} className="sectionText hidden lg:block">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};
